var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllianzLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_9247)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2367 70.2467V20.5873C51.2367 16.6298 49.8204 15.2955 45.9551 15.2955H34.2495V20.8777H34.9531C37.6214 20.8777 38.1422 21.4768 38.1422 24.6718V70.2467H51.2367ZM57.0119 70.2467H70.0059V31.5702C70.0059 27.6854 68.4981 26.2875 64.6876 26.2875H57.0119V70.2467ZM32.4037 70.2467V26.3238H24.7005C20.89 26.3238 19.4005 27.7217 19.4005 31.6066V70.2467H32.4037ZM82.3054 45.004C82.3054 66.8883 66.4604 82.8 44.7032 82.8C22.946 82.8 7.06445 66.8883 7.06445 45.004C7.06445 23.1197 22.9369 7.20799 44.7032 7.20799C66.4695 7.20799 82.3054 23.2105 82.3054 45.004ZM89.9995 45.004C89.9995 19.2711 70.6181 0.000976562 44.7032 0.000976562C18.7883 0.000976562 -0.611328 19.2711 -0.611328 45.004C-0.611328 70.7368 18.77 89.9979 44.7032 89.9979C70.6364 89.9979 89.9995 70.8004 89.9995 45.004Z",
    fill: "#B1B5C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_114_9247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 91,
    height: 90
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2367 70.2467V20.5873C51.2367 16.6298 49.8204 15.2955 45.9551 15.2955H34.2495V20.8777H34.9531C37.6214 20.8777 38.1422 21.4768 38.1422 24.6718V70.2467H51.2367ZM57.0119 70.2467H70.0059V31.5702C70.0059 27.6854 68.4981 26.2875 64.6876 26.2875H57.0119V70.2467ZM32.4037 70.2467V26.3238H24.7005C20.89 26.3238 19.4005 27.7217 19.4005 31.6066V70.2467H32.4037ZM82.3054 45.004C82.3054 66.8883 66.4604 82.8 44.7032 82.8C22.946 82.8 7.06445 66.8883 7.06445 45.004C7.06445 23.1197 22.9369 7.20799 44.7032 7.20799C66.4695 7.20799 82.3054 23.2105 82.3054 45.004ZM89.9995 45.004C89.9995 19.2711 70.6181 0.000976562 44.7032 0.000976562C18.7883 0.000976562 -0.611328 19.2711 -0.611328 45.004C-0.611328 70.7368 18.77 89.9979 44.7032 89.9979C70.6364 89.9979 89.9995 70.8004 89.9995 45.004Z",
    fill: "#F4F6F9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_114_9247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.402 183.451L6.84164 -142.744L14.4835 -149.059L284.044 177.136L276.402 183.451ZM261.24 191.868L-8.32042 -134.327L-0.678523 -140.642L268.882 185.553L261.24 191.868Z",
    fill: "#8F9352",
    style: {
      mixBlendMode: "screen"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_9247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllianzLogoMini);
export default __webpack_public_path__ + "static/media/allianz-logo-mini.bc64b43accca8022988fc5d9183eea10.svg";
export { ForwardRef as ReactComponent };